import { daysBetweenDates } from 'app/shared/utils/dates';
import { MeterEntriesConfirmationMessageStatus } from 'common/model/meterReadings/meterEntriesValidateSuccess';

const WARNING_DEVIATION = 25;
const ALARM_DEVIATION = 50;

export const getCurrentAverageConsumption = (consumption: number, lastEntryDate: Date): number => {
    return consumption / (daysBetweenDates(new Date(), lastEntryDate));
};

export const getDeviationConsuption = (
    averageDailyConsumption: number, consumption: number, lastEntryDate: Date
): number => {
    return ((getCurrentAverageConsumption(consumption, lastEntryDate) - averageDailyConsumption) / averageDailyConsumption) * 100;
};

export const getDeviationConsuptionStatus = (
    averageDailyConsumption: number, consumption: number, lastEntryDate: Date
): MeterEntriesConfirmationMessageStatus => {
    let deviation = getDeviationConsuption(averageDailyConsumption, consumption, lastEntryDate);

    if (deviation < 0) {
        return 'normal';
    }

    deviation = Math.abs(deviation);

    if (WARNING_DEVIATION <= deviation && deviation < ALARM_DEVIATION) {
        return 'warning';
    }
    if (ALARM_DEVIATION <= deviation) {
        return 'alert';
    }

    return 'normal';

};
